module.exports = __webpack_public_path__ + "static/media/11_plantilla_menu_comida_24.c3bfbc32.png";